import { ROUTE } from 'const/routes'

import { ExpandableSidebarItems } from './Sidebar.types'

export const getExpandableSidebarItemFromPath = (
  pathname: string
): ExpandableSidebarItems => {
  if (
    pathname.includes(ROUTE.PORTAL_PAYMENTS) &&
    !pathname.includes('/sites') &&
    !pathname.includes('/virtual-terminal')
  ) {
    return 'Payments'
  }

  if (pathname.includes(ROUTE.PORTAL_SETTINGS)) {
    return 'Settings'
  }

  return 'NONE'
}
